export const EXAM_STATUS = {
  PASSED_NOT_PUBLISHED: 1,
  FAILED_NOT_PUBLISHED: 2,
  SKIPPED: 3,
  NOT_REVIEWED: 4,
  PASSED: 5,
  FAILED: 6,
} as const;

export type ExamStatusIds = (typeof EXAM_STATUS)[keyof typeof EXAM_STATUS];
